module.exports = __webpack_public_path__ + "media/images/common/about/icon_car-8219e047e19391afd3e1487165851330.svg";